import React from "react";
import { Typography, Box } from "@mui/material";
import styled from "@emotion/styled";
import FilePondUploader from "../FilePondUploader";
import AttachmentBox from "../AttachmentBox";

const SectionLabel = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const ExistingList = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const StepAttachments = ({ setAttachments, onUploadStatusChange, existingAttachments = [], onRemoveExisting }) => {
    return (
        <Box>
            <SectionLabel variant="subtitle2">
                Attach files to this template (optional)
            </SectionLabel>
            {existingAttachments.length > 0 && (
                <ExistingList>
                    {existingAttachments.map((attachment) => (
                        <AttachmentBox
                            key={attachment.storageKey}
                            attachment={attachment}
                            onRemove={() => onRemoveExisting && onRemoveExisting(attachment.storageKey)}
                        />
                    ))}
                </ExistingList>
            )}
            <FilePondUploader setAttachments={setAttachments} onUploadStatusChange={onUploadStatusChange} />
        </Box>
    );
};

export default StepAttachments;
